// src/navItems.js
import React from 'react';
import BoltIcon from '@mui/icons-material/Bolt';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PeopleIcon from '@mui/icons-material/People';
import CheckroomIcon from '@mui/icons-material/Checkroom';
import QuestionAnswerRoundedIcon from '@mui/icons-material/QuestionAnswerRounded';
import EventIcon from '@mui/icons-material/Event';
import CallIcon from '@mui/icons-material/Call';
import SubscriptionsIcon from '@mui/icons-material/Subscriptions';
import LiveHelpIcon from '@mui/icons-material/LiveHelp';
import SettingsAccessibilityIcon from '@mui/icons-material/SettingsAccessibility';
import LocalMallIcon from '@mui/icons-material/LocalMall';
import StraightenIcon from '@mui/icons-material/Straighten';
import AppShortcutIcon from '@mui/icons-material/AppShortcut';
import CategoryIcon from '@mui/icons-material/Category';
import ViewListIcon from '@mui/icons-material/ViewList';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import BlockIcon from '@mui/icons-material/Block';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import SettingsIcon from '@mui/icons-material/Settings';
import HistoryIcon from '@mui/icons-material/History';
import BugReportIcon from '@mui/icons-material/BugReport';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import RateReviewIcon from '@mui/icons-material/RateReview';
import GavelIcon from '@mui/icons-material/Gavel';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import CampaignIcon from '@mui/icons-material/Campaign';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import QueryStatsIcon from '@mui/icons-material/QueryStats';

// Grouped navigation structure with collapsible groups
export const navGroups = [
  {
    label: null, // No group label for Dashboard
    items: [
      { label: 'Dashboard', icon: <DashboardIcon fontSize="small" />, table: 'Home', path: '/dashboard' },
      { label: 'Analytics', icon: <DashboardIcon fontSize="small" />, table: 'Analytics', path: '/dashboard/analytics', permission: 'dashboard' },
      { label: 'Pulse', icon: <BoltIcon fontSize="small" />, table: 'Pulse', path: '/dashboard/pulse', permission: 'dashboard' },
      { label: 'Business Metrics', icon: <QueryStatsIcon fontSize="small" />, table: 'Business Metrics', path: '/dashboard/business-metrics', permission: 'dashboard' },
    ],
    collapsible: false,
  },
  {
    label: 'Management',
    items: [
      { label: 'Profiles', icon: <PeopleIcon fontSize="small" />, table: 'Profiles', path: '/dashboard/profiles', permission: 'profiles' },
      { label: 'Closet Items', icon: <CheckroomIcon fontSize="small" />, table: 'Closet Items', path: '/dashboard/closet', permission: 'closet_items' },
      { label: 'Bookings', icon: <EventIcon fontSize="small" />, table: 'bookings', path: '/dashboard/bookings', permission: 'bookings' },
      { label: 'Reviews & Comments', icon: <RateReviewIcon fontSize="small" />, table: 'Reviews', path: '/dashboard/reviews', permission: 'reviews' },
      { label: 'Stylist Approval', icon: <HowToRegIcon fontSize="small" />, table: 'Stylist Approval', path: '/dashboard/stylist-approval', permission: 'profiles' },
      { label: 'Reports Queue', icon: <BlockIcon fontSize="small" />, table: 'Reports Queue', path: '/dashboard/reports-queue', permission: 'blocked_users' },
      { label: 'Legal Compliance', icon: <GavelIcon fontSize="small" />, table: 'Legal Compliance', path: '/dashboard/legal-compliance', permission: 'legal_compliance' },
      { label: 'Blocked Users', icon: <BlockIcon fontSize="small" />, table: 'Blocked Users', path: '/dashboard/blocked-users', permission: 'blocked_users' },
    ],
    collapsible: true,
    defaultOpen: true,
  },
  {
    label: 'Finance',
    items: [
      { label: 'Payments', icon: <CreditCardIcon fontSize="small" />, table: 'payments', path: '/dashboard/payments', permission: 'payments' },
      { label: 'Payouts', icon: <AccountBalanceWalletIcon fontSize="small" />, table: 'Payouts', path: '/dashboard/payouts', permission: 'payouts' },
      { label: 'Disputes', icon: <GavelIcon fontSize="small" />, table: 'Disputes', path: '/dashboard/disputes', permission: 'payments' },
      { label: 'Shopping Budgets', icon: <ShoppingBagIcon fontSize="small" />, table: 'Shopping Budgets', path: '/dashboard/shopping-budgets', permission: 'payments' },
    ],
    collapsible: true,
    defaultOpen: false,
  },
  {
    label: 'Communication',
    items: [
      { label: 'Chats', icon: <QuestionAnswerRoundedIcon fontSize="small" />, table: 'Chats', path: '/dashboard/chats', permission: 'chats' },
      { label: 'Contact Us', icon: <CallIcon fontSize="small" />, table: 'Contact Us', path: '/dashboard/contact', permission: 'contact_us' },
      { label: 'Marketing', icon: <CampaignIcon fontSize="small" />, table: 'Marketing', path: '/dashboard/marketing', permission: 'marketing' },
      { label: 'Coupons', icon: <LocalOfferIcon fontSize="small" />, table: 'Coupons', path: '/dashboard/coupons', permission: 'marketing' },
    ],
    collapsible: true,
    defaultOpen: false,
  },
  {
    label: 'App Settings',
    items: [
      { label: 'Brands', icon: <LocalMallIcon fontSize="small" />, table: 'Brands', path: '/dashboard/brands', permission: 'brands' },
      { label: 'Size', icon: <StraightenIcon fontSize="small" />, table: 'Size', path: '/dashboard/sizes', permission: 'sizes' },
      { label: 'Body Type', icon: <SettingsAccessibilityIcon fontSize="small" />, table: 'Body Type', path: '/dashboard/body-types', permission: 'body_types' },
      { label: 'Style Pref.', icon: <AppShortcutIcon fontSize="small" />, table: 'Style Preference', path: '/dashboard/styles', permission: 'style_preferences' },
      { label: 'Categories', icon: <CategoryIcon fontSize="small" />, table: 'Category List', path: '/dashboard/categories', permission: 'categories' },
      { label: 'Sub Categories', icon: <ViewListIcon fontSize="small" />, table: 'SubCategory', path: '/dashboard/subcategories', permission: 'subcategories' },
      { label: 'Subscriptions', icon: <SubscriptionsIcon fontSize="small" />, table: 'Subscriptions', path: '/dashboard/subscriptions', permission: 'subscriptions' },
      { label: 'FAQs', icon: <LiveHelpIcon fontSize="small" />, table: 'FAQs', path: '/dashboard/faqs', permission: 'faqs' },
    ],
    collapsible: true,
    defaultOpen: false,
  },
  {
    label: 'System',
    items: [
      { label: 'Issues & Errors', icon: <BugReportIcon fontSize="small" />, table: 'Issues', path: '/dashboard/issues', permission: 'issues' },
      // The audit checklist was a tab inside System Settings, which meant the
      // only way to reach it was to open a page about file upload limits and
      // notice a second tab. It is its own entry now, next to Issues & Errors
      // where the rest of "what is wrong with the app" lives. The page itself
      // is still owner-gated on the server.
      { label: 'Audit Checklist', icon: <FactCheckIcon fontSize="small" />, table: 'Audit Checklist', path: '/dashboard/audit-checklist', permission: 'issues' },
      { label: 'Activity Logs', icon: <HistoryIcon fontSize="small" />, table: 'Activity Logs', path: '/dashboard/activity-logs', permission: 'activity_logs' },
      { label: 'System Settings', icon: <SettingsIcon fontSize="small" />, table: 'System Settings', path: '/dashboard/settings', permission: 'system_settings' },
      { label: 'User Management', icon: <AdminPanelSettingsIcon fontSize="small" />, table: 'User Management', path: '/dashboard/user-management', permission: 'user_management' },
    ],
    collapsible: true,
    defaultOpen: false,
  },
];

// Flattened navItems for backward compatibility
const navItems = navGroups.flatMap(group => group.items);

export default navItems;
